import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getIsSearchCompleted} from 'modules/sapiSearch/selectors'
import {toggle} from 'opticks'

import {getQueryStringObject} from '@daedalus/core/src/_web/utils/url'
import {isHotelAdsVerifierFromUrl} from '@daedalus/core/src/rateChecker/business'

interface Props {
  isAnchor: boolean
}

/**
 * This an attempt to fix tracking issues with the rate checker
 * It's adds a delay to show the rates after the search is completed
 * to make sure the events are sent before the rate checker closes the page
 *
 * @param isAnchor - Whether the offer is an anchor offer
 * @returns Whether the loading state should be shown
 */
export const useRateCheckerDelay = ({isAnchor}: Props) => {
  const [isLoading, setIsLoading] = useState(true)
  const searchParams = getQueryStringObject()
  const isHotelAdsVerifier = isHotelAdsVerifierFromUrl(searchParams)
  const isSearchCompleted = useSelector(getIsSearchCompleted)
  const isEnabled = toggle('feature-gha-rate-checker-delay', false, true)

  useEffect(() => {
    let timeoutId = null

    if (isEnabled && isAnchor && isHotelAdsVerifier) {
      if (isSearchCompleted) {
        // 1 second delay to show the loading state
        timeoutId = setTimeout(() => {
          setIsLoading(false)
        }, 1000)
      }
    } else {
      setIsLoading(false)
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [isEnabled, isSearchCompleted, isHotelAdsVerifier, setIsLoading, isAnchor])

  return isLoading
}
